import { Component, effect, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import LogRocket from 'logrocket';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { Store } from '@ngxs/store';
import { UserStateSelectors } from '../store/users-store/user.selectors';
import { AUTH_ROUTES } from '../constants';
import { AppStartAction } from '../store/general-store/general.actions';
import { NoSubscriptionBannerComponent } from './components/shared-components/no-subscription-banner/no-subscription-banner.component';
import { filter } from 'rxjs';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { isSuperAdmin } from './services/global.service';
import { ActivityFeedComponent } from './components/shared-components/activity-feed/activity-feed.component';
import { RoutePermissionCheckComponent } from './components/shared-components/route-permission-check/route-permission-check.component';
import { CommonModule } from '@angular/common';
import { PrimeNG } from 'primeng/config';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProductStateSelectors } from '../store/products-store/products.selectors';
import { QrStateSelectors } from '../store/qr-store/qr.selectors';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { GeneralStateSelectors } from '../store/general-store/general.selectors';
import { DashboardStateSelectors } from '../store/dashboard-store/dashboard.selectors';

import { TraceabilitySelectors } from '../store/traceability-store/traceability.selectors';

LogRocket.init('d6wj4w/regenesis');

LogRocket.identify('App Started');

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    SidebarComponent,
    CommonModule,
    NoSubscriptionBannerComponent,
    ConfirmDialogModule,
    ActivityFeedComponent,
    RoutePermissionCheckComponent,
    NgScrollbarModule,
    ProgressBarModule,
    ProgressSpinnerModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly primeng = inject(PrimeNG);

  title = 'regenesis';
  isSidebarExpanded = false;
  isActivityFeedCollapsed = false;
  currUser$ = this.store.selectSignal(UserStateSelectors.getUser);
  showSubscriptionBanner = true;
  showActivityFeed = false;

  isProcessingProducts$ = this.store.selectSignal(ProductStateSelectors.isProcessing);
  isProcessingQrOrder$ = this.store.selectSignal(QrStateSelectors.isProcessing);
  isProcessingUser$ = this.store.selectSignal(UserStateSelectors.isLoading);
  isProcessingDashboard$ = this.store.selectSignal(DashboardStateSelectors.isLoading);
  isProcessingTraceability$ = this.store.selectSignal(TraceabilitySelectors.isLoading);
  appLoading$ = this.store.selectSignal(GeneralStateSelectors.appLoading);

  constructor() {
    this.store.dispatch(new AppStartAction());

    effect(() => {
      if (this.currUser$() && isSuperAdmin(this.currUser$())) {
        this.showSubscriptionBanner = false;
      }
    });
  }

  ngOnInit() {
    this.primeng.ripple.set(true);
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd), // Only consider navigation end events
      )
      .subscribe((event: any) => {
        if (
          event.url.includes('subscription') ||
          event.url.includes('home') ||
          isSuperAdmin(this.currUser$())
        ) {
          this.showSubscriptionBanner = false;
        } else {
          this.showSubscriptionBanner = true;
        }

        if (
          (event.url.includes('dashboards') && !event.url.includes('traceability')) ||
          event.url.includes('home')
        ) {
          this.showActivityFeed = true;
        } else {
          this.showActivityFeed = false;
        }
      });
  }

  toggleSidebar() {
    this.isSidebarExpanded = !this.isSidebarExpanded;
  }

  notAnAuthRoute() {
    return !AUTH_ROUTES.includes(this.router.url.split('?')[0]);
  }
}
